import styled from 'styled-components';

export const CarouselContainer = styled.div`
  && {
    .carousel .control-dots {
      position: relative;
      margin: 10px 0;
      padding: 0;
      text-align: center;
      bottom: 7px;
      right: auto;
      width: 100%;
      height: 8px;
    }
    .direction {
      direction: initial;
    }

    .carousel .control-dots li:hover {
      opacity: 0.3;
    }

    .carousel .slide {
      text-align: start;
      border-radius: 8px;
    }
  }
`;
